import React from "react";
import { useLang } from "@/i18n";
import MediaSlot from "@/components/MediaSlot";

const ITEMS = {
  customer: { url: "/media/review-customer.mp4", poster: "/media/review-customer.jpg" },
  worker: { url: "/media/review-worker.mp4", poster: "/media/review-worker.jpg" },
};

export default function ReviewVideo({ kind, dark = false }) {
  const { t } = useLang();
  return (
    <section data-testid={`review-${kind}`} className={`chela-section ${dark ? "bg-[#121316] text-[#FAF8F5]" : ""}`}>
      <div className="chela-container grid md:grid-cols-12 gap-8 items-center">
        <div className="md:col-span-5">
          <span className="eyebrow">{t("rv_eyebrow")}</span>
          <h2 className={`mt-4 font-display font-bold tracking-tight text-3xl sm:text-4xl ${dark ? "text-white" : "text-[#121316]"}`}>{t(`rv_${kind}_h`)}</h2>
          <p className={`mt-4 text-base sm:text-lg leading-relaxed ${dark ? "text-white/75" : "text-[#5A5D65]"}`}>{t(`rv_${kind}_p`)}</p>
        </div>
        <div className="md:col-span-7 flex justify-center">
          <div className="w-full max-w-[340px] rounded-[2rem] overflow-hidden border border-[#E5E0D8] shadow-[0_30px_70px_rgba(0,0,0,0.18)]">
            <MediaSlot slot={ITEMS[kind]} mode="tap" alt={t(`rv_${kind}_h`)} className="w-full aspect-[9/16] object-cover" testid={`review-${kind}-video`} />
          </div>
        </div>
      </div>
    </section>
  );
}
